import { useCallback, useEffect, useState } from "react";

import { apiErrorMessage } from "../services/utilities";

/**
 * Ask for a new cassette on the doc a feed client reads (TT-1273, the
 * platform's doc model): a replay or batch processing of the source, its
 * algorithms named, kept beside the others. The platform queues it and
 * answers with the cassette's header; nothing is replaced, and the page
 * follows the new cassette through the same band read as any other.
 *
 * Returns { request(body), pending, cassette, error }. A client without
 * `requestCassette` (a public viewer's) can ask for nothing.
 */
export default function useCassetteRequest(feed) {
  const [pending, setPending] = useState(false);
  const [cassette, setCassette] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    setPending(false);
    setCassette(null);
    setError("");
  }, [feed]);

  const request = useCallback(
    async (body) => {
      if (!feed?.requestCassette) return;
      setPending(true);
      setError("");
      try {
        const res = await feed.requestCassette(body);
        if (!res || res.error) {
          setError(apiErrorMessage(res, "Unable to make the cassette"));
          return;
        }
        setCassette(res.cassette || null);
      } finally {
        setPending(false);
      }
    },
    [feed]
  );

  return { request, pending, cassette, error };
}
